export default __webpack_public_path__ + "static/media/Liberar Catracas.dbed143d.svg";